import { Center } from '@chakra-ui/react';
import Link from 'next/link';
import { AiFillHome } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { FiSettings } from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";

export const HomeIconLink = () => {
  return (
    <Link href={`/home`}>
      <Center>
        <AiFillHome
          fontSize="inherit"
          style={{ fontSize: "3.5rem", color: "#707C97" }}
        />
      </Center>
    </Link>
  )
}

export const TicketIconLink = () => {
  return (
    <Link href={`/tickets`}>
      <Center>
        <HiOutlineMail
          fontSize="inherit"
          style={{ fontSize: "3.5rem", color: "#707C97" }}
        />
      </Center>
    </Link>
  )
}

export const AccountIconLink = () => {
  return (
    <Link href={`/customers`}>
      <Center>
        <BsFillPersonFill
          fontSize="inherit"
          style={{ fontSize: "3.5rem", color: "#707C97" }}
        />
      </Center>
    </Link>
  )
}

export const SettingsIconLink = () => {
  return (
    <Link href={`/settings`}>
      <Center>
        <FiSettings
          fontSize="inherit"
          style={{ fontSize: "3.5rem", color: "#707C97" }}
        />
      </Center>
    </Link>
  )
}
